import { useAuthStore } from '../stores/auth-store';
import type { Login } from '@gmao/shared';

export function useAuth() {
  const {
    user,
    isAuthenticated,
    isLoading,
    error,
    login,
    logout,
    clearError,
    setAuthData,
  } = useAuthStore();

  const handleLogin = async (credentials: Login) => {
    await login(credentials);
  };

  const handleLogout = async () => {
    await logout();
  };

  const hasRole = (role: string | string[]) => {
    if (!user) return false;

    const roles = Array.isArray(role) ? role : [role];
    return roles.includes(user.role);
  };

  const hasPermission = (permission: string) => {
    if (!user) return false;

    // Administrator has all permissions
    if (user.role === 'administrator') return true;

    // Check effective permissions
    return user.effective_permissions?.includes(permission) || false;
  };

  return {
    user,
    isAuthenticated,
    isLoading,
    error,
    login: handleLogin,
    logout: handleLogout,
    clearError,
    setAuthData,
    hasRole,
    hasPermission,
  };
}
